import cn from 'classnames';
import queryString from 'query-string';
import React from 'react';
import { useTranslation } from 'react-i18next';
import mapPinIcon from './mapPinIcon.svg';
import Meta from './Meta';

export interface Props {
  memberCount: number;
  url: string;
  img: string;
  title: string;
  location?: string;
  owner: {
    name: string;
  };
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export default React.memo(function TeamResultCard({
  memberCount,
  url,
  img,
  title,
  location,
  onClick,
}: Props) {
  const { t } = useTranslation();
  return (
    <div
      className={cn('jg-search-result-card', 'jg-display-flex jg-flex-column')}
      data-testid="jg-search-result-card"
    >
      <a
        href={url}
        onClick={onClick}
        className={cn(
          'jg-search-result-card__inner',
          'jg-text-no-underline@hover',
          'jg-background--white-smoke@hover',
          'jg-space-pxs jg-space-mbsm',
          'jg-space-pn@md jg-space-msm@md',
          'jg-br jg-bd@md jg-bd--very-light-grey@md',
          'jg-flex-g1 jg-display-flex jg-flex-column'
        )}
      >
        <div
          className={cn(
            'jg-search-result-card__image-ratio-wrapper',
            'jg-position-relative jg-space-mbxs jg-space-mbn@md'
          )}
        >
          {[
            'jg-search-result-card__image jg-search-result-card__image--bg',
            'jg-search-result-card__image',
          ].map(classNames => (
            <div
              key={classNames}
              className={cn(
                'jg-search-result-card__image-wrapper',
                'jg-position-absolute jg-pin',
                'jg-bd jg-bd--very-light-grey',
                'jg-bdhn@md jg-bdtn@md',
                'jg-display-flex jg-flex-aic jg-flex-jcc'
              )}
            >
              <img
                className={cn(classNames, 'lazyload')}
                data-src={`${
                  queryString.parseUrl(img).url
                }?template=CampaignHeroSmall`}
                alt=""
              />
            </div>
          ))}
        </div>

        <div className="jg-space-psm@md jg-flex-g1 jg-display-flex jg-flex-column">
          <div className="jg-flex-g1">
            <h3
              className={cn(
                'jg-search-result-card__title',
                'jg-text--large-regular jg-color--nero jg-space-mbxs'
              )}
            >
              {title}
            </h3>

            {location && <Meta icon={mapPinIcon} text={location} />}
          </div>

          <div
            aria-label={t(
              'resultCard.teamsv1.membersAriaLabel',
              'Number of team members'
            )}
            className={cn(
              'jg-display-flex jg-flex-aic',
              'jg-space-mtxs@md',
              'jg-space-mtsm@lg',
              'jg-text--medium',
              'jg-color--nero'
            )}
          >
            {t('resultCard.teamsv1.member', {
              defaultValue: '{{count}} Member',
              count: memberCount,
            })}
          </div>
        </div>
      </a>
    </div>
  );
});
